import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ShareBox from 'sushiweb/Icons/all/ShareBox';
import {
  Container,
  Header,
  HeaderGradient,
  HeaderLogo,
  HeaderTitle,
  Content,
  Title,
  Subtitle,
  VoucherCard,
  VoucherLabel,
  VoucherValue,
  CopyButton,
  VoucherRow,
  InfoSection,
  InfoItem,
  InfoText,
  Footer,
  LogoBox,
  LogoContainer,
  PrimaryButton,
} from './styles';
import {
  B_LOGO,
  BISTRO_LOGO_WHITE,
  D_LOGO_WHITE,
  E_LOGO_WHITE,
  Z_LOGO_WHITE,
} from '../../constants/images';
import { entityTypeEnum } from '../common/components/constants';
import { getEntityColor, getEntityName } from '../../helpers';

const getEntityLogo = entity => {
  switch (entity) {
    case entityTypeEnum.BLINKIT_USER:
      return B_LOGO;
    case entityTypeEnum.ZOMATO_USER:
      return Z_LOGO_WHITE;
    case entityTypeEnum.DISTRICT_USER:
      return D_LOGO_WHITE;
    default:
      return null;
  }
};

const GiftCardDetails = ({ data }) => {
  const [copiedField, setCopiedField] = useState('');

  const {
    Code = '',
    Pin = '',
    Amount = '',
    EntityType = entityTypeEnum.UNKNOWN,
    ClaimLink = 'Blinkit',
  } = data;

  const handleCopy = async (text, field) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedField(field);
      setTimeout(() => setCopiedField(''), 2000);
    } catch (err) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopiedField(field);
      setTimeout(() => setCopiedField(''), 2000);
    }
  };

  const handleRedeem = () => {
    window.open(ClaimLink, '_blank');
  };

  return (
    <Container>
      <Header>
        <HeaderGradient>
          <HeaderLogo src={E_LOGO_WHITE} alt='Eternal Logo' />
          <HeaderTitle>Happy Diwali from all of us at Eternal</HeaderTitle>
        </HeaderGradient>
      </Header>

      <Content>
        <LogoContainer>
          <LogoBox bgColor={getEntityColor(EntityType)}>
            <img
              src={getEntityLogo(EntityType)}
              alt='Eternal Logo'
              width={40}
            />
          </LogoBox>
          {EntityType === entityTypeEnum.BLINKIT_USER && (
            <LogoBox bgColor='#00DD6E'>
              <img src={BISTRO_LOGO_WHITE} alt='Eternal Logo' width={40} />
            </LogoBox>
          )}
        </LogoContainer>

        <Title>
          Your 
          {' '}
          <span>
            {' '}
            ₹
            {Amount}
            {' '}
 
          </span>
          {' '}
          {EntityType === entityTypeEnum.BLINKIT_USER
            ? `${getEntityName(EntityType)} & Bistro`
            : getEntityName(EntityType)}
          {' '}
          voucher is ready!
        </Title>

        <Subtitle>
          Copy the VOUCHER
          {' '}
          {EntityType === entityTypeEnum.BLINKIT_USER ? 'CODE and PIN' : 'PIN'}
          {' '}
          below and redeem it on 
          {' '}
          {getEntityName(EntityType)}
        </Subtitle>

        <VoucherCard>
          <VoucherRow>
            <div>
              <VoucherLabel>Voucher Code</VoucherLabel>
              <VoucherValue>{Code}</VoucherValue>
            </div>
            {EntityType === entityTypeEnum.BLINKIT_USER && (
              <CopyButton
                onClick={() => handleCopy(Code, 'code')}
                copied={copiedField === 'code'}
                type='button'
              >
                {copiedField === 'code' ? '✓ Copied' : 'Copy'}
              </CopyButton>
            )}
          </VoucherRow>
        </VoucherCard>

        <VoucherCard>
          <VoucherRow>
            <div>
              <VoucherLabel>Voucher PIN</VoucherLabel>
              <VoucherValue>{Pin}</VoucherValue>
            </div>
            <CopyButton
              onClick={() => handleCopy(Pin, 'pin')}
              copied={copiedField === 'pin'}
              type='button'
            >
              {copiedField === 'pin' ? '✓ Copied' : 'Copy'}
            </CopyButton>
          </VoucherRow>
        </VoucherCard>

        <InfoSection>
          <InfoItem>
            <InfoText>
              Once applied, the amount will be instantly added to your
              {' '}
              {getEntityName(EntityType)}
              {' '}
              wallet.
            </InfoText>
          </InfoItem>
        </InfoSection>
      </Content>

      <Footer>
        <PrimaryButton
          onClick={handleRedeem}
          size='large'
          fullWidth
          iconAlign='right'
        >
          <span className='button-icon'>
            <ShareBox color='#ffffff' size={16} />
          </span>
          Redeem on 
          {' '}
          {getEntityName(EntityType)}
        </PrimaryButton>
      </Footer>
    </Container>
  );
};

GiftCardDetails.propTypes = {
  data: PropTypes.shape({
    Code: PropTypes.string,
    Pin: PropTypes.string,
    Amount: PropTypes.string,
    ExpiryDate: PropTypes.string,
    ClaimLink: PropTypes.string,
    EntityType: PropTypes.number,
  }),
};

GiftCardDetails.defaultProps = {
  data: {},
};

export default GiftCardDetails;
